<template>
  <div class="wrapper-content w-100">
    <h1>{{form.titulo}}</h1>
    <LmBreadcrumb />
    <LmForm ref="lmFormRef">
      <LmTextInput
        v-model="form.title"
        :v="$v.form.title"
        label="Título"
        placeholder="Título"
        />
      <LmTextInput
        v-model="form.notificationbody"
        :v="$v.form.notificationbody"
        label="Detalle"
        placeholder="Detalle"
        :maxLength="256"
        />
      <LmUploadFiles
        label="Imagen"
        ref="lmUploadFiles"
        class="mb-3"
        :dropzoneOptions="dropzoneOptions"
        dictDefaultMessage='Arrastre la imagen acá para subirla'
        @vdropzone-removed-file="fileRemoved"
        @vdropzone-success="fileCreated"
      />
      <LmSelect
        v-model="form.tipoenlacedestino"
        :options="tipoEnlaceDestinoOptions"
        label="Tipo de enlace de destino"
        @input="cleanAllValuesFromSelect"
        />
       <LmTextInput
        v-if="form.tipoenlacedestino === 'url-externa'"
        v-model="form.externalUrl"
        :v="$v.form.externalUrl"
        label="Url Externa"
        placeholder="Url Externa"
        />
      <div v-if="form.tipoenlacedestino === 'marca'" class="row">
        <LmSuperPowerSelect
          class="col-12"
          :data="lmSuperPowerSelects.marca.selectOptions"
          :tbColumns="lmSuperPowerSelects.marca.tbColumns"
          :v="$v.form.marcaId"
          label="Marca"
          placeholder="Marca"
          :model="sanitizeModel(form.marcaId)"
          @values="updateMarca($event)"
        />
      </div>
      <div v-if="form.tipoenlacedestino === 'filtro'" class="row">
        <LmSuperPowerSelect
          class="col-12"
          :data="lmSuperPowerSelects.filtro.selectOptions"
          :tbColumns="lmSuperPowerSelects.filtro.tbColumns"
          :v="$v.form.filtroId"
          label="Filtro"
          placeholder="Filtro"
          :model="sanitizeModel(form.filtroId)"
          @values="updateFiltro($event)"
        />
      </div>
      <div v-if="form.tipoenlacedestino === 'sorteo'" class="row">
        <LmSuperPowerSelect
          class="col-12"
          :data="lmSuperPowerSelects.sorteo.selectOptions"
          :tbColumns="lmSuperPowerSelects.sorteo.tbColumns"
          :v="$v.form.sorteoId"
          label="Sorteo"
          placeholder="Sorteo"
          :model="sanitizeModel(form.sorteoId)"
          @values="updateSorteo($event)"
        />
      </div>
      <div v-if="form.tipoenlacedestino === 'landing'" class="row">
        <LmSuperPowerSelect
          class="col-12"
          :data="lmSuperPowerSelects.landing.selectOptions"
          :tbColumns="lmSuperPowerSelects.landing.tbColumns"
          :v="$v.form.landingId"
          label="Landing"
          placeholder="Landing"
          :model="sanitizeModel(form.landingId)"
          @values="updateLanding($event)"
        />
      </div>
      <div v-if="form.tipoenlacedestino === 'branded-content-o-nota-patrocinada'" class="row">
        <LmSuperPowerSelect
          class="col-12"
          :data="lmSuperPowerSelects.nota.selectOptions"
          :tbColumns="lmSuperPowerSelects.nota.tbColumns"
          :v="$v.form.notaId"
          label="Nota"
          placeholder="Nota"
          :model="sanitizeModel(form.notaId)"
          @values="updateNota($event)"
        />
      </div>
      <div class="row">
        <LmSuperPowerSelect
          class="col-12"
          :data="lmSuperPowerSelects.segmentos.selectOptions"
          :tbColumns="lmSuperPowerSelects.segmentos.tbColumns"
          :v="$v.form.segmentid"
          label="Segmentos"
          placeholder="Segmentos"
          :model="sanitizeModel(form.segmentid)"
          @values="updateSegment($event)"
        />
      </div>
      <LmButton
        type="button"
        buttonClass="btn-secondary"
        :isProcessing="isFormProcessing"
        :value="$t('Cancel')"
        @click.native="cancelBtn"
        lmButtonRootWrapperClass="d-inline-block mr-1"
        lmButtonWrapperClass="col"
      />
      <LmButton
        type="submit"
        buttonClass="btn-primary"
        :isProcessing="isFormProcessing"
        value="Guardar Borrador"
        lmButtonRootWrapperClass="d-inline-block mr-1"
        lmButtonWrapperClass="col"
        @click.native="submit('BO', true)"
        />
      <LmButton
        type="submit"
        buttonClass="btn-success"
        :isProcessing="isFormProcessing"
        value="Enviar Ahora"
        lmButtonRootWrapperClass="d-inline-block mr-1"
        lmButtonWrapperClass="col"
        @click.native="submit('LE', true)"
        />
      <LmButton
        type="submit"
        buttonClass="btn-success"
        :isProcessing="isFormProcessing"
        value="Programar Envío"
        lmButtonRootWrapperClass="d-inline-block mr-1"
        lmButtonWrapperClass="col"
        @click.native="scheduleModal"
        />
    </LmForm>
    <b-modal
      id="modal-scheduled-send"
      title="Programar Envío"
      no-close-on-backdrop
      @ok="okHandlerModalSheduledSend"
      @cancel="scheduledSendCancel"
      @close="scheduledSendCancel"
      @shown="modalScheduledSendIsVissible = true"
      @hidden="modalScheduledSendIsVissible = false"
      >
      <LmDateTime
        v-model="form.datesend"
        :v="$v.form.datesend"
        :config="lmDateTimeConfig"
        placeholder="Seleccione fecha y hora que desea enviar la notifiación."
        label="Seleccione fecha y hora que desea enviar la notifiación."
        id="selectDate"
        :layout="['form-group']"
      />
    </b-modal>
  </div>
</template>

<script>
import { required, requiredIf, maxLength } from 'vuelidate/lib/validators'
import axios from 'axios'
import store from '@/store'
import { Spanish } from 'flatpickr/dist/l10n/es.js'

import LmDateTime from '@/components/form/elements/LmDateTime'
import LmForm from '@/components/form/LmForm.vue'
import LmTextInput from '@/components/form/elements/LmTextInput'
import LmDate from '@/components/form/elements/LmDate'
import LmUploadFiles from '@/components/LmUploadFiles'
import LmSuperPowerSelect from '@/components/form/elements/LmSuperPowerSelect.vue'
import lmSuperPowerSelectHelper from '@/mixins/LmSuperPowerSelectHelper.js'
import LmSelect from '@/components/form/elements/LmSelect'
import LmButton from '@/components/form/elements/LmButton'

export default {
  mixins: [lmSuperPowerSelectHelper],
  components: {
    LmForm,
    LmTextInput,
    LmDate,
    LmSuperPowerSelect,
    LmButton,
    LmUploadFiles,
    LmDateTime,
    LmSelect
  },
  data () {
    return {
      modalScheduledSendIsVissible: false,
      tipoEnlaceDestinoOptions: {
        content: [
          { value: 'marca', text: 'Marca' },
          { value: 'url-externa', text: 'URL externa' },
          { value: 'branded-content-o-nota-patrocinada', text: 'Branded content' },
          { value: 'filtro', text: 'Filtro' },
          { value: 'landing', text: 'Landing' },
          { value: 'sorteo', text: 'Sorteo' },
          { value: 'home', text: 'Home' }
        ]
      },
      lmSuperPowerSelects: {
        segmentos: {
          selectOptions: [],
          tbColumns: [
            { title: 'Segmento', data: 'name' }
          ]
        },
        marca: {
          selectOptions: [],
          tbColumns: [
            { title: 'Marca', data: 'name' }
          ]
        },
        nota: {
          selectOptions: [],
          tbColumns: [
            { title: 'Nota', data: 'name' }
          ]
        },
        filtro: {
          selectOptions: [],
          tbColumns: [
            { title: 'Filtro', data: 'name' }
          ]
        },
        landing: {
          selectOptions: [],
          tbColumns: [
            { title: 'Landing', data: 'name' }
          ]
        },
        sorteo: {
          selectOptions: [],
          tbColumns: [
            { title: 'Sorteo', data: 'name' }
          ]
        }
      },
      files: [],
      optionsState: {
        content: [
          { value: 'BO', text: 'Borrador' },
          { value: 'LE', text: 'Lista para enviar' }
        ]
      },
      form: {
        title: '',
        datesend: '',
        notificationbody: '',
        externalUrl: '',
        segmentid: null,
        marcaId: null,
        notaId: null,
        filtroId: null,
        landingId: null,
        sorteoId: null,
        urlimagen: null,
        state: null,
        tipoenlacedestino: 'marca'
      },
      initialForm: {},
      isFormProcessing: false,
      lmDateTimeConfig: {
        dateFormat: 'Y-m-d H:i',
        locale: Spanish,
        allowInput: true,
        enableTime: true,
        minDate: 'today'
      },
      dropzoneOptions: {
        url: `${process.env.VUE_APP_API_URL}documentos/nuevo/`,
        headers: {
          'Cache-Control': null,
          'X-Requested-With': null,
          Authorization: `Bearer ${store.state.session.accessToken}`
        },
        withCredentials: true,
        thumbnailWidth: 150,
        maxFiles: 1,
        addRemoveLinks: true,
        acceptedFiles: 'image/*'
      }
    }
  },
  validations: {
    form: {
      title: {
        required
      },
      datesend: {
        required: requiredIf(function () { return this.modalScheduledSendIsVissible })
      },
      notificationbody: {
        required,
        maxLength: maxLength(256)
      },
      externalUrl: {
        required: requiredIf(function () { return this.form.tipoenlacedestino === 'url-externa' })
      },
      marcaId: {
        required: requiredIf(function () { return this.form.tipoenlacedestino === 'marca' })
      },
      notaId: {
        required: requiredIf(function () { return this.form.tipoenlacedestino === 'branded-content-o-nota-patrocinada' })
      },
      filtroId: {
        required: requiredIf(function () { return this.form.tipoenlacedestino === 'filtro' })
      },
      landingId: {
        required: requiredIf(function () { return this.form.tipoenlacedestino === 'landing' })
      },
      sorteoId: {
        required: requiredIf(function () { return this.form.tipoenlacedestino === 'sorteo' })
      },
      segmentid: {
        required
      },
      state: {
        required
      },
      tipoenlacedestino: {
        required
      }
    }
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    enableGoBackButton: {
      type: Boolean,
      required: false,
      default: false
    },
    isOnEditMode: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    async scheduleModal () {
      this.form.state = 'PR'
      await this.$refs.lmFormRef.validationForm(this.$v)
      this.$v.form.datesend.$reset()
      this.$bvModal.show('modal-scheduled-send')
    },
    async okHandlerModalSheduledSend (bvModalEvt) {
      bvModalEvt.preventDefault()
      await this.$refs.lmFormRef.validationForm(this.$v)
      this.submit('PR', false)
    },
    cleanAllValuesFromSelect () {
      this.form.externalUrl = ''
      this.form.marcaId = ''
      this.form.notaId = ''
      this.form.filtroId = ''
      this.form.landingId = ''
      this.form.sorteoId = ''
      this.form.home = ''
    },
    scheduledSendCancel () {
      if (!this.isOnEditMode) {
        this.form.datesend = ''
      }
    },
    cancelBtn () {
      this.$router.go(-1)
    },
    updateSegment (values) {
      let value = values[0]
      this.form.segmentid = value ? value.id : null
    },
    updateMarca (values) {
      let value = values[0]
      this.form.marcaId = value ? value.id : null
    },
    updateNota (values) {
      let value = values[0]
      this.form.notaId = value ? value.id : null
    },
    updateFiltro (values) {
      let value = values[0]
      this.form.filtroId = value ? value.id : null
    },
    updateLanding (values) {
      let value = values[0]
      this.form.landingId = value ? value.id : null
    },
    updateSorteo (values) {
      let value = values[0]
      this.form.sorteoId = value ? value.id : null
    },
    async setForm () {
      if (this.isOnEditMode) {
        this.$refs.lmFormRef.activeEditMode({
          path: 'notificaciones',
          id: this.$route.params.id,
          paramsMode: true
        })
          .then(() => {
            if (this.form.urlimagen) {
              const fileOption = {
                size: 100000
              }
              this.$refs.lmUploadFiles.lmManuallyAddFile(fileOption, this.form.apiUrlPath + this.form.urlimagen)
            }
          })
          .catch(error => {
            console.log(error)
            this.$router.replace({ name: '404' })
          })
      } else {
        this.form = JSON.parse(this.initialForm)
        setTimeout(() => {
          this.$v.$reset()
        }, 5)
      }
      try {
        this.$refs.lmFormRef.showLoading()
        const response = await this.getAllLmSuperPowerSelectOptions(
          [
            {
              name: 'segmentos',
              obj: {
                path: 'segmentador/',
                total: null
              }
            },
            {
              name: 'marca',
              obj: {
                path: 'marcas/todos/',
                total: null
              }
            },
            {
              name: 'nota',
              obj: {
                path: 'brandedcontent/todos/',
                total: null
              }
            },
            {
              name: 'filtro',
              obj: {
                path: 'filtros/todos/',
                total: null
              }
            },
            {
              name: 'landing',
              obj: {
                path: 'landings/todos/',
                total: null
              }
            },
            {
              name: 'sorteo',
              obj: {
                path: 'sorteos/todos/',
                total: null
              }
            }
          ])
        response.forEach(element => {
          if (element.name === 'segmentos') {
            const data = element.data.map(e => ({ id: e.hidden_id, name: e.hidden_titulo }))
            this.lmSuperPowerSelects[element.name].selectOptions = data
          } else {
            this.lmSuperPowerSelects[element.name].selectOptions = element.data
          }
        })
      } finally {
        this.$refs.lmFormRef.hideLoading()
      }
    },
    toastError (error) {
      this.$bvToast.toast(error.response.data.message, {
        title: error.response.data.error,
        autoHideDelay: 500000,
        toaster: 'b-toaster-bottom-center',
        variant: 'danger',
        solid: true
      })
    },
    fileCreated (file, response) {
      if (response) {
        this.files.push(response)
      }
      this.$refs.lmUploadFiles.disable()
    },
    fileRemoved (file, error, xhr) {
      this.form.urlimagen = ''
      if (file) {
        this.files = this.files.filter(f => f.originalname !== file.name)
      }
      this.$refs.lmUploadFiles.enable()
    },
    async submit (formState, isNotScheduledSend) {
      this.form.state = formState
      if (isNotScheduledSend) {
        this.form.datesend = null
      }
      try {
        this.isFormProcessing = true
        await this.$refs.lmFormRef.validationForm(this.$v)
        const fileLoaded = this.files.length ? this.files[0].path : ''
        const dataToSendToTheServer = {
          id: this.form.id,
          d_titulo: this.form.title,
          f_envio: this.form.datesend,
          d_texto: this.form.notificationbody,
          d_url_imagen: this.form.urlimagen || fileLoaded,
          d_url_destino: this.form.externalUrl,
          n_segmento: this.form.segmentid,
          c_estado: this.form.state,
          tipo_notificacion: this.form.tipoenlacedestino,
          d_notificacion: this.form.externalUrl || this.form.marcaId?.toString() || this.form.notaId?.toString() || this.form.filtroId?.toString() || this.form.landingId?.toString() || this.form.sorteoId?.toString(),
          procesada: 'N'
        }
        let apiUrl = this.isOnEditMode ? `${process.env.VUE_APP_API_URL}notificaciones/update/` : `${process.env.VUE_APP_API_URL}notificaciones/new/`
        await axios.post(
          apiUrl,
          dataToSendToTheServer,
          {
            headers: {
              Authorization: `Bearer ${store.state.session.accessToken}`
            }
          }
        )
        this.$router.push('/notificaciones/listado')
      } catch (error) {
        console.log('error', error)
      } finally {
        this.isFormProcessing = false
      }
    }
  },
  watch: {
    isOnEditMode () {
      this.setForm()
    }
  },
  created () {
    this.initialForm = JSON.stringify(this.form)
  },
  mounted () {
    this.setForm()
  }
}
</script>
